import type { ReactNode } from "react";
import { SampleHeader } from "./SampleHeader";
import { SampleSidebar } from "./SampleSidebar";

type SampleLayoutProps = {
  children: ReactNode;
};

export function SampleLayout({ children }: SampleLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-100">
      <SampleSidebar />
      <SampleHeader />
      <main className="ml-[270px] pt-12">
        <div className="p-5">{children}</div>
      </main>
    </div>
  );
}
